// Breadcrumbs.js
import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation(); // Get the current location
  const pathnames = location.pathname.split('/').filter((x) => x); // Split the path into segments

  return (
    <div>
      <nav>
        <ul style={{ listStyleType: 'none', padding: 0, display: 'flex' }}>
          <li>
            <Link to="/dashboard">Home</Link>
          </li>
          {pathnames.map((value, index) => {
            const path = `/${pathnames.slice(0, index + 1).join('/')}`;
            return (
              <li key={path} style={{ marginLeft: '10px' }}>
                <span> / </span>
                <Link to={path}>{value.charAt(0).toUpperCase() + value.slice(1)}</Link>
              </li>
            );
          })}
        </ul>
      
      </nav>
    </div>
  );
};

export default Breadcrumbs;
